// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"209":"ebc7bcfbb6a70c14","236":"fb5c8b06f2cd953e"}[chunkId] + ".js";
};